//账单

export default [
    {   //库存异动单客户端
        path: "inventory/adjustmentclient",
        name: "inventorAdjustmentClient",
        component: () => import(/* webpackChunkName: "inventoryadjustment" */ "@/views/inventory/adjustmentclient/index"),
    },
    {   //销毁计划编辑
        path: "inventory/adjustment/detail/:type",
        name: "adjustmentDetail",
        component: () => import(/* webpackChunkName: "inventoryadjustment" */ "@/views/inventory/adjustmentclient/detail.vue"),
    },
    {   //库存异动单管理端
        path: "inventory/adjustmentmanage",
        name: "inventorAdjustmentManage",
        component: () => import(/* webpackChunkName: "inventoryadjustment" */ "@/views/inventory/adjustmentmanage/index"),
    }
]


